import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TemplateTypes } from '@lbmx/per-form-primeng';
import { ToastrNotificationService } from '@lbmx/phoenix-lib-utils';
import { HttpMethod, Request } from '@lbmx/web-core';
import { TranslocoService } from '@ngneat/transloco';
import { apiUrls } from 'src/app/layouts/secure/url-config';
import { ConfigProvider } from 'src/app/provider/config-provider';

@Component({
  selector: 'app-user-profile-wizard',
  templateUrl: './user-profile-wizard.component.html',
})
export class UserProfileWizardComponent implements OnInit {
  public wizardConfig: Request;
  public wizardUrl = '';
  public templateTypes = TemplateTypes;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastrNotificationService,
    public translocoService: TranslocoService,
    private configPrv: ConfigProvider
  ) {}

  public ngOnInit(): void {
    this.wizardUrl = this.configPrv.AppSetting.uriBase.apiBaseUrl;
    this.wizardConfig = {
      endpoint: apiUrls.userProfileWizard(),
      httpMethod: HttpMethod.POST,
    };
  }

  public redirect() {
    this.router.navigate(['/home']);
  }
  public submit(event) {
    this.toast.successNotify(
      this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE')
    );
  }
}
